export default [

     {
          path: '/schedule',
          name: 'schedule',
         component: () => import("@/views/Page/schedule/schedule.vue"),
           meta: {
               title: '#Default# | schedule',
          },
     }
];